export enum VenueRouterMode {
    ALWAYS = 'ALWAYS',
    LAST_VENUE = 'LAST_VENUE',
    DIRECT = 'DIRECT',
}
